export const getAllLanguagesEndpoint = 'languages';
